import { PackageLine, DimensionUnit } from '@freight-cbm/shared-types';
import { AlertTriangle } from 'lucide-react';

interface UnitWarningProps {
  pkg: PackageLine;
}

export function UnitWarning({ pkg }: UnitWarningProps) {
  // Detect potential unit confusion: very large dimensions in cm or very small in m
  const warnings: string[] = [];

  if (pkg.dimUnit === DimensionUnit.Cm) {
    if (pkg.length > 300 || pkg.width > 300 || pkg.height > 300) {
      warnings.push('Dimensions are very large for cm. Did you mean meters?');
    }
  }
  if (pkg.dimUnit === DimensionUnit.M) {
    if (pkg.length < 0.1 && pkg.width < 0.1 && pkg.height < 0.1 && pkg.length > 0) {
      warnings.push('Dimensions are very small for meters. Did you mean cm?');
    }
  }
  if (pkg.dimUnit === DimensionUnit.Mm) {
    if (pkg.length > 3000 || pkg.width > 3000 || pkg.height > 3000) {
      warnings.push('Dimensions are very large for mm. Did you mean cm?');
    }
  }

  if (warnings.length === 0) return null;

  return (
    <div
      role="alert"
      style={{
        padding: 'var(--space-1) var(--space-2)',
        fontSize: 'var(--font-size-xs)',
        color: 'var(--color-warning)',
        background: 'var(--color-warning-light)',
        borderRadius: 'var(--radius-sm)',
        marginTop: 'var(--space-1)',
      }}
    >
      <AlertTriangle size={12} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 'var(--space-1)' }} /> {warnings[0]}
    </div>
  );
}
